/**
 * Process-fairness flag types (Gap 3).
 *
 * A lightweight way for a participant to signal that the *process* did not treat
 * their input fairly. Deliberately a flag, not an appeal workflow — it can be
 * acknowledged and resolved with a note; that is the whole lifecycle.
 */

export type FairnessConcernType =
  | 'vote_suppressed'
  | 'not_heard'
  | 'process_unfair'
  | 'criteria_biased'
  | 'other';

export type FairnessFlagStatus = 'open' | 'acknowledged' | 'resolved' | 'dismissed';

export interface FairnessFlag {
  id: string;
  sessionId: string;
  toolSessionId?: string | null;
  workspaceId: string;
  raisedBy: string;
  raisedByName: string;
  concernType: FairnessConcernType;
  note?: string | null;
  status: FairnessFlagStatus;
  acknowledgedBy?: string | null;
  acknowledgedByName?: string | null;
  acknowledgedAt?: string | null;
  resolutionNote?: string | null;
  createdAt: string;
  updatedAt: string;
}

export const FAIRNESS_CONCERN_LABELS: Record<FairnessConcernType, string> = {
  vote_suppressed: 'My input was excluded or overridden',
  not_heard: "I wasn't given a chance to weigh in",
  process_unfair: 'The process felt unfair',
  criteria_biased: 'The criteria or scales were slanted',
  other: 'Something else',
};
